var EmbedType = /* @__PURE__ */ function(EmbedType2) {
  EmbedType2["YOUTUBE"] = "youtube";
  EmbedType2["VIMEO"] = "vimeo";
  EmbedType2["TWITTER"] = "twitter";
  EmbedType2["SPOTIFY"] = "spotify";
  return EmbedType2;
}({});

export { EmbedType };
//# sourceMappingURL=expandedResource.types.js.map
